import { render, staticRenderFns } from "./CheckpointSuggestionContent.vue?vue&type=template&id=41f72cca&scoped=true"
import script from "./CheckpointSuggestionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointSuggestionContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointSuggestionContent.vue?vue&type=style&index=0&id=41f72cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f72cca",
  null
  
)

export default component.exports